// extracted by mini-css-extract-plugin
module.exports = {"overlayWrapper":"ModalOverlay_overlayWrapper__23CQH","overlayButton":"ModalOverlay_overlayButton__2L9RH","wrapper":"ModalOverlay_wrapper__TfhIo"};